import Deferred from "utils/Deferred";

/**
 * Promise always fired when Datalayer is done processing and ready.
 * @returns {Promise} of ready event data
 */
const datalayerReady = new Deferred();
export default datalayerReady;
